module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb735d3c52484dfdc864f4066e212ad7.png";